// extracted by mini-css-extract-plugin
module.exports = {"drawerRoot":"LeftMenuContainer_drawerRoot__g9rY8","drawerPaper":"LeftMenuContainer_drawerPaper__1EdG3"};